module.exports = __webpack_public_path__ + "img/card-2.60c0eae7.png";